// extracted by mini-css-extract-plugin
export default {"container":"styles-module--container--1b759","flourish":"styles-module--flourish--9892c","content":"styles-module--content--b41f0","flipped":"styles-module--flipped--9c3de"};